/* ==========================================================================
   Cube Club x Thrudaruf - product page
   THD-CUB-2026-01 - v1 - 7 Aug 2026

   Five independent pieces, each safe on its own:
     1. gallery      - thumbnail -> stage, videos autoplay muted on select
     2. variants     - multi-option picker, price/stock/image/url sync
     3. watch strip  - the clips under Buy it now, autoplay in view
     4. sticky bar   - appears when the real Add to cart scrolls out
     5. pincode      - delivery date + COD, below the buttons

   Everything degrades: with JS off you still get the first image, the first
   variant preselected and a working cart form.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var thrifty = conn.saveData === true || /^(slow-)?2g$/.test(conn.effectiveType || '');
  var autoOK = !reduce && !thrifty;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* lazily attach a <source> so nothing downloads before it is needed */
  function attach(video) {
    if (!video || video.dataset.done) return video;
    video.dataset.done = '1';
    var src = video.getAttribute('data-src');
    if (!src) return video;
    var s = document.createElement('source');
    s.src = src; s.type = 'video/mp4';
    video.appendChild(s);
    video.load();
    return video;
  }

  /* ====================================================================== */
  function gallery(root) {
    var thumbs = $$('[data-tdp-thumb]', root);
    var slides = $$('[data-tdp-slide]', root);
    if (!thumbs.length || !slides.length) return;
    var sound = $('[data-tdp-sound]', root);

    function show(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-on', on);
        var v = s.querySelector('video');
        if (!v) return;
        if (on) {
          attach(v);
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () { v.controls = true; });
        } else { v.pause(); }
      });
      var cur = slides[i] && slides[i].querySelector('video');
      if (sound) sound.hidden = !cur;
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    if (sound) {
      sound.addEventListener('click', function () {
        var on = $('.tdp-gal__slide.is-on video', root);
        if (!on) return;
        on.muted = !on.muted;
        sound.textContent = on.muted ? 'Sound off' : 'Sound on';
      });
    }

    root.tdpShowMedia = function (id) {
      for (var n = 0; n < thumbs.length; n++) {
        if (thumbs[n].getAttribute('data-media') === String(id)) {
          show(n);
          root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          return true;
        }
      }
      return false;
    };
    root.tdpShowImage = function (id) {
      for (var n = 0; n < thumbs.length; n++) {
        if (thumbs[n].getAttribute('data-media') === String(id)) { show(n); return true; }
      }
      return false;
    };

    show(0);
  }

  /* ====================================================================== */
  function variants(root) {
    var dataEl = $('[data-tdp-variants]', root);
    if (!dataEl) return;
    var list;
    try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!list || !list.length) return;

    var groups   = $$('[data-tdp-optgroup]', root);
    var idInput  = $('[data-tdp-varid]', root);
    var priceNow = $('[data-tdp-now]', root);
    var priceWas = $('[data-tdp-was]', root);
    var priceSav = $('[data-tdp-save]', root);
    var emiEl    = $('[data-tdp-emi]', root);
    var stockEl  = $('[data-tdp-stock]', root);
    var atc      = $('[data-tdp-atc]', root);
    var payWrap  = $('[data-tdp-pay]', root);
    var gal      = $('[data-tdp-gallery]', root);
    var sTitle   = $('[data-tdp-sticky-variant]', root);
    var sPrice   = $('[data-tdp-sticky-price]', root);
    var sBtn     = $('[data-tdp-sticky-btn]', root);
    var emiMonths= parseInt(root.getAttribute('data-emi-months') || '12', 10);
    var lowAt    = parseInt(root.getAttribute('data-low-at') || '20', 10);

    /* Prices arrive pre-formatted from Liquid (price_f / compare_f / emi_f).
       Reimplementing Indian currency grouping in JS would only create a
       second source of truth that drifts from the shop money format. */

    function chosen() {
      return groups.map(function (g) {
        var on = g.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function match(sel) {
      for (var i = 0; i < list.length; i++) {
        var ok = true;
        for (var k = 0; k < sel.length; k++) {
          if (sel[k] !== null && list[i].options[k] !== sel[k]) { ok = false; break; }
        }
        if (ok) return list[i];
      }
      return null;
    }

    /* grey out an option value when no in-stock variant carries it */
    function repaint(sel) {
      groups.forEach(function (g, gi) {
        $$('[data-value]', g).forEach(function (b) {
          var val = b.getAttribute('data-value');
          var any = list.some(function (v) {
            for (var k = 0; k < sel.length; k++) {
              if (k !== gi && sel[k] !== null && v.options[k] !== sel[k]) return false;
            }
            return v.options[gi] === val && v.available;
          });
          b.classList.toggle('is-oos', !any);
        });
      });
    }

    function apply(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;

      if (priceNow) priceNow.textContent = v.price_f;
      if (priceWas) {
        if (v.compare_f) {
          priceWas.textContent = v.compare_f; priceWas.hidden = false;
          if (priceSav) { priceSav.textContent = 'Save ' + v.save + '%'; priceSav.hidden = false; }
        } else {
          priceWas.hidden = true;
          if (priceSav) priceSav.hidden = true;
        }
      }
      if (emiEl) {
        if (v.emi_f) {
          emiEl.textContent = 'or ' + v.emi_f + '/mo × ' + emiMonths + ' · no-cost EMI';
          emiEl.hidden = false;
        } else { emiEl.hidden = true; }
      }

      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!v.available) { stockEl.textContent = 'Out of stock'; stockEl.classList.add('is-out'); }
        else if (v.qty !== null && v.qty > 0 && v.qty <= lowAt) {
          stockEl.textContent = 'Only ' + v.qty + ' left · ships in 3 days';
          stockEl.classList.add('is-low');
        } else { stockEl.textContent = 'In stock · ships in 3 days'; }
      }

      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (payWrap) payWrap.hidden = !v.available;
      if (sBtn) { sBtn.disabled = !v.available; sBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (sPrice) sPrice.textContent = v.price_f;
      if (sTitle) sTitle.textContent = v.title;

      if (gal && v.media_id && gal.tdpShowImage) gal.tdpShowImage(v.media_id);

      if (window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }

    groups.forEach(function (g, gi) {
      $$('[data-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-value]', g).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          var lab = g.querySelector('[data-tdp-optsel]');
          if (lab) lab.textContent = b.getAttribute('data-value');

          var sel = chosen();
          var v = match(sel);
          /* the exact combination may not exist - fall back to the first
             variant honouring the option the user just touched */
          if (!v) {
            var relax = sel.slice();
            for (var k = 0; k < relax.length; k++) { if (k !== gi) relax[k] = null; }
            v = match(relax);
            if (v) {
              groups.forEach(function (g2, i2) {
                $$('[data-value]', g2).forEach(function (o) {
                  o.setAttribute('aria-pressed', o.getAttribute('data-value') === v.options[i2] ? 'true' : 'false');
                });
                var l2 = g2.querySelector('[data-tdp-optsel]');
                if (l2) l2.textContent = v.options[i2];
              });
            }
          }
          repaint(chosen());
          apply(v);
        });
      });
    });

    repaint(chosen());
  }

  /* ====================================================================== */
  function watch(root) {
    var items = $$('[data-tdp-watch]', root);
    if (!items.length) return;
    var gal = $('[data-tdp-gallery]', root);

    items.forEach(function (it) {
      var v = it.querySelector('video');

      it.addEventListener('click', function () {
        var id = it.getAttribute('data-media');
        if (gal && gal.tdpShowMedia && id) gal.tdpShowMedia(id);
      });

      if (!autoOK || !('IntersectionObserver' in window) || !v) {
        it.classList.add('is-manual');
        return;
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            attach(v);
            var pr = v.play();
            if (pr && pr.then) {
              pr.then(function () { it.classList.add('is-playing'); })
                .catch(function () { it.classList.add('is-manual'); });
            } else { it.classList.add('is-playing'); }
          } else {
            v.pause();
            it.classList.remove('is-playing');
          }
        });
      }, { threshold: 0.5 }).observe(it);
    });
  }

  /* ====================================================================== */
  function sticky(root) {
    var bar = $('[data-tdp-sticky]', root);
    var anchor = $('[data-tdp-cta]', root);
    var form = $('.tdp-cta form', root);
    if (!bar || !anchor) return;

    var btn = $('[data-tdp-sticky-btn]', bar);
    if (btn && form) {
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ====================================================================== */
  function pincode(root) {
    var wrap = $('[data-tdp-pin]', root);
    if (!wrap) return;
    var input = $('.tdp-pin__in', wrap);
    var go    = $('.tdp-pin__go', wrap);
    var out   = $('.tdp-pin__out', wrap);
    if (!input || !go || !out) return;

    var dMin = parseInt(wrap.getAttribute('data-days-min') || '3', 10);
    var dMax = parseInt(wrap.getAttribute('data-days-max') || '6', 10);
    var noCod = (wrap.getAttribute('data-no-cod') || '').split(',')
                  .map(function (s) { return s.trim(); }).filter(Boolean);

    function fmt(d) { return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); }

    function run() {
      var pin = (input.value || '').replace(/\D/g, '');
      out.classList.remove('is-err');
      if (pin.length !== 6) {
        out.classList.add('is-err');
        out.textContent = 'Enter a 6-digit pincode.';
        return;
      }
      var a = new Date(), b = new Date();
      a.setDate(a.getDate() + dMin);
      b.setDate(b.getDate() + dMax);
      var cod = !noCod.some(function (pfx) { return pin.indexOf(pfx) === 0; });
      out.innerHTML = 'Delivered <b>' + fmt(a) + ' &ndash; ' + fmt(b) + '</b> to ' + pin +
                      ' &middot; Free' +
                      (cod ? ' &middot; <b>Cash on delivery available</b>'
                           : ' &middot; Prepaid only at this pincode');
      try { localStorage.setItem('tdfPin', pin); } catch (e) {}
    }

    go.addEventListener('click', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    try {
      var saved = localStorage.getItem('tdfPin');
      if (saved) { input.value = saved; run(); }
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- boot */
  function init(scope) {
    $$('[data-tdp-root]', scope || document).forEach(function (root) {
      if (root.dataset.booted) return;
      root.dataset.booted = '1';
      var gal = $('[data-tdp-gallery]', root);
      if (gal) gallery(gal);
      variants(root);
      watch(root);
      sticky(root);
      pincode(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

;(function () {
  'use strict';
  var handle = 'neoprene-dumbbells-0-5-kg-pair';
  if (location.pathname.split('/').pop() !== handle) return;
  function init() {
    var root = document.querySelector('[data-tdp-root]');
    var gallery = root && root.querySelector('[data-tdp-gallery]');
    if (!gallery || gallery.dataset.ccVariantSets) return;
    gallery.dataset.ccVariantSets = 'loading';
    var route = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    fetch(route + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Product image data unavailable'); return r.json(); })
      .then(function (product) {
        var sets = {};
        product.images.forEach(function (src) {
          var match = src.match(/\/cc-neoprene-(0p5|[1-5])kg-(\d{2})(?:[_.])/);
          if (!match) return;
          if (!sets[match[1]]) sets[match[1]] = [];
          sets[match[1]].push({ src: src, order: Number(match[2]) });
        });
        if (!['0p5','1','2','3','4','5'].every(function (key) {
          return sets[key] && sets[key].length === 8 && new Set(sets[key].map(function (x) { return x.order; })).size === 8;
        })) throw new Error('Incomplete variant image sets');
        Object.keys(sets).forEach(function (key) { sets[key].sort(function (a,b) { return a.order-b.order; }); });
        var rail = gallery.querySelector('.tdp-gal__thumbs');
        var stage = gallery.querySelector('.tdp-gal__stage');
        if (!rail || !stage) throw new Error('Gallery structure unavailable');
        var currentKey = '';
        function imageUrl(src, width) {
          var url = new URL(src, location.origin);
          url.searchParams.set('width', width);
          return url.href;
        }
        function render() {
          var input = root.querySelector('[data-tdp-varid]');
          var id = input && input.value || new URL(location.href).searchParams.get('variant');
          var variant = product.variants.find(function (v) { return String(v.id) === String(id); }) || product.variants[0];
          var key = String(variant.option1 || variant.title).toLowerCase().replace(/\s*kg\s*/g, '').replace('.', 'p');
          if (!sets[key] || key === currentKey) return;
          currentKey = key;
          gallery.querySelectorAll('video').forEach(function (video) { video.pause(); });
          rail.replaceChildren();
          stage.querySelectorAll('[data-tdp-slide]').forEach(function (slide) { slide.remove(); });
          var sound = gallery.querySelector('[data-tdp-sound]');
          if (sound) sound.hidden = true;
          var buttons = [], slides = [];
          function show(index) {
            buttons.forEach(function (button, i) { button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
            slides.forEach(function (slide, i) { slide.classList.toggle('is-on', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
          }
          sets[key].forEach(function (asset, i) {
            var label = product.title + ', ' + variant.title + ', image ' + (i+1);
            var button = document.createElement('button');
            button.type = 'button'; button.className = 'tdp-gal__t';
            button.setAttribute('role', 'tab'); button.setAttribute('aria-label', label);
            button.setAttribute('data-tdp-thumb', ''); button.dataset.media = 'cc-' + key + '-' + asset.order;
            var thumb = document.createElement('img');
            thumb.src = imageUrl(asset.src, 160); thumb.alt = ''; thumb.width = 160; thumb.height = 160; thumb.loading = 'lazy';
            button.appendChild(thumb);
            var slide = document.createElement('div');
            slide.className = 'tdp-gal__slide'; slide.setAttribute('data-tdp-slide', ''); slide.dataset.media = button.dataset.media;
            var img = document.createElement('img');
            img.src = imageUrl(asset.src, 1200); img.srcset = imageUrl(asset.src, 600) + ' 600w, ' + imageUrl(asset.src, 1200) + ' 1200w, ' + imageUrl(asset.src, 1600) + ' 1600w';
            img.sizes = '(max-width: 899px) 100vw, 46vw'; img.alt = label; img.width = 1500; img.height = 1500;
            img.loading = i === 0 ? 'eager' : 'lazy';
            slide.appendChild(img); rail.appendChild(button); stage.appendChild(slide);
            buttons.push(button); slides.push(slide);
            button.addEventListener('click', function () { show(i); });
            button.addEventListener('keydown', function (event) {
              var n = i;
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') n = (i+1)%buttons.length;
              else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') n = (i+buttons.length-1)%buttons.length;
              else if (event.key === 'Home') n = 0;
              else if (event.key === 'End') n = buttons.length-1;
              else return;
              event.preventDefault(); show(n); buttons[n].focus();
            });
          });
          show(0); rail.scrollTop = 0; rail.scrollLeft = 0;
          gallery.dataset.ccSelectedWeight = variant.title;
        }
        gallery.tdpShowImage = function () { render(); return true; };
        root.addEventListener('click', function (event) { if (event.target.closest('[data-value]')) render(); });
        window.addEventListener('popstate', render);
        render(); gallery.dataset.ccVariantSets = 'ready';
      }).catch(function () { delete gallery.dataset.ccVariantSets; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
